// extracted by mini-css-extract-plugin
export var btn = "N_mY C_tl C_tb d_bz d_bP d_bD d_dw";
export var full = "N_wg d_w d_H";
export var hoverStyle = "N_m1";
export var zoom = "N_m2";